export type WebpackModule<T> = { default: T }

export type WebpackModuleFactory<T> = () => Promise<WebpackModule<T>>

export type WebpackScope = {
  loaded?: 1
  get: () => Promise<unknown>
  from: string
  eager: boolean
}

export enum WebpackSharedScopesOptions {
  Default = 'default',
}

export type WebpackSharedScopes = Record<WebpackSharedScopesOptions, Record<string, WebpackScope>>

export type WebpackRemoteContainer = {
  get: <T>(moduleName: string) => Promise<WebpackModuleFactory<T>>
  init: (sharedScope: Record<string, WebpackScope>) => Promise<void>
}
